/*
* Javascript for the your-account page
* Should only work if member is logged in
*/
var updateAddressCurrentPosition = {
	lat: 0,
	lng: 0
},
updateAddressMap,
updateAddressMarker,
updateAddressMapWithCoordinates;

(function ($) {
	if ($('body.update-meeting-address').length) {
		//If #actualLatitude and #actualLongitude exist, use them as the center
		if ($('#actualLatitude').val() && $('#actualLongitude').val()) {
			var center = {
				lat: parseFloat($('#actualLatitude').val()),
				lng: parseFloat($('#actualLongitude').val())
			};
		} else if ($('#address2_latitude').val() && $('#address2_longitude').val()) {
			var center = {
				lat: parseFloat($('#address2_latitude').val()),
				lng: parseFloat($('#address2_longitude').val())
			};
		} 

		async function initMap() {
			const { Map } = await google.maps.importLibrary("maps");
			const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

			updateAddressMap = new Map(document.getElementById("map"), {
				center: center,
				zoom: 18,
				mapId: '10c54dda61bbc61b',
			});

			var pinSVGHole = "M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z";

			var search_icon = {
				path: pinSVGHole,
				anchor: new google.maps.Point(12, 17),
				fillOpacity: 1,
				fillColor: '#2bb2bc',
				strokeWeight: 1,
				strokeColor: "#1c9da0",
				scale: 2,
			},
			search_icon_hover = {
				path: pinSVGHole,
				anchor: new google.maps.Point(12, 17),
				fillOpacity: 1,
				fillColor: '#3c4981',
				strokeWeight: 1,
				strokeColor: "#2e3d6b",
				scale: 2,
			};

			updateAddressMarker = new google.maps.Marker({
				position: center,
				map: updateAddressMap,
				draggable: true,
				icon: search_icon
			});

			google.maps.event.addListener(updateAddressMarker, 'dragend', function (event) {
				updateAddressCurrentPosition = {
					lat: event.latLng.lat(),
					lng: event.latLng.lng()
				};
				updateCoordinates();
			});
		}

		function updateCoordinates() {
			//Update the #address2_latitude and #address2_longitude fields
			$('#address2_latitude').val(updateAddressCurrentPosition.lat);
			$('#address2_longitude').val(updateAddressCurrentPosition.lng);

			//Update the #actualLatitude and #actualLongitude fields
			$('#actualLatitude').val(updateAddressCurrentPosition.lat);
			$('#actualLongitude').val(updateAddressCurrentPosition.lng);
		}

		function setCenterAndMarker(newCenter) {
			updateAddressMap.setCenter(newCenter);
			updateAddressMarker.setPosition(newCenter);
		}

		updateAddressMapWithCoordinates = function(lat, lng) {
			var newCenter = {
				lat: lat,
				lng: lng
			};
			setCenterAndMarker(newCenter);
		}


		document.addEventListener("DOMContentLoaded", function () {
			initMap();
			updateCoordinates();
		});
	}
})(jQuery);
